import { PricingType } from 'src/common/external/bambi-api/bambiApi';

export function formatPricingTypeRounding(pricingType: PricingType) {
  return `${pricingType.rounding} to the ${pricingType.unit.toLowerCase()}`;
}
